import React, { useRef, useEffect, useState } from "react";

// TODO: once store and state management is implemented, can move the logic from listnotes for the search feature in here. logic was added
// to listnotes instead of here to minimize prop drilling.

export default function SearchBar({ searchQuery, setSearchQuery }) {
  const pathName = window.location.pathname;
  const measureRef = useRef(null);
  const inputRef = useRef(null);
  const [inputWidth, setInputWidth] = useState('auto');
  const placeholderText = "Search by Name or MRN/DOB/SSN";

  useEffect(() => {
    if (measureRef.current && inputRef.current) {
      const width = measureRef.current.offsetWidth;
      // Add padding for icon (pl-10 = 40px) and right padding (pr-4 = 16px)
      setInputWidth(`${width + 56}px`);
    }
  }, []);

  useEffect(() => {
    if (inputRef.current && searchQuery) {
      // When user types, measure the actual text width
      const tempSpan = document.createElement('span');
      tempSpan.style.visibility = 'hidden';
      tempSpan.style.position = 'absolute';
      tempSpan.style.whiteSpace = 'nowrap';
      tempSpan.style.fontSize = window.getComputedStyle(inputRef.current).fontSize;
      tempSpan.style.fontFamily = window.getComputedStyle(inputRef.current).fontFamily;
      tempSpan.textContent = searchQuery || placeholderText;
      document.body.appendChild(tempSpan);
      const width = tempSpan.offsetWidth;
      document.body.removeChild(tempSpan);
      // Add padding for icon and right padding
      setInputWidth(`${Math.max(width + 56, measureRef.current?.offsetWidth + 56 || 200)}px`);
    } else if (measureRef.current) {
      // Reset to placeholder width when empty
      const width = measureRef.current.offsetWidth;
      setInputWidth(`${width + 56}px`);
    }
  }, [searchQuery, placeholderText]);

  const handleInputChange = (event) => {
    setSearchQuery(event.target.value);
  };

  return (
    <div className="mt-3 relative items-center ">
      <span
        ref={measureRef}
        className="absolute invisible whitespace-nowrap text-light-grey"
        style={{ fontSize: 'inherit', fontFamily: 'inherit' }}
      >
        {placeholderText}
      </span>
      <input
        ref={inputRef}
        type="text"
        aria-label="Search patients by name, medical record number, date of birth, or Social Security number"
        placeholder={placeholderText}
        value={searchQuery}
        onChange={handleInputChange}
        className="border-0 focus:placeholder-white shadow-knowtex-shadow rounded-xl pl-10 pr-4 py-2 text-light-grey"
        style={{ width: inputWidth }}
      />

      <svg
        className="absolute left-3 top-1/2 transform -translate-y-1/2 w-6 h-6 text-light-grey "
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth="2"
          d="m21 21-3.5-3.5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
        />
      </svg>
    </div>
  );
}
